import { Route, Routes } from 'react-router-dom';

import B2BPortal from './B2BPortal';

function App() {
  return (
    <Routes>
      <Route path="/" element={<B2BPortal />} />
      {/* <Route path="/" element={<B2BPortal />} /> */}
    </Routes>
  );
}

export default App;